<template>
  <billing-layout>
    <div class="page-breadcrumb">
        <div class="row">
            <div class="col-5 align-self-center">
            </div>
            <div class="col-7 align-self-center">
                <div class="d-flex align-items-center justify-content-end">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                               <!-- <a href="#"  class="btn btn-success"><i class="fas fa-plus"></i> Create New</a> -->
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-md-6">
                  <router-link :to="{name : 'PaymentsReceivedNew'}" class="btn btn-success">
                    <i class="fas fa-plus"></i> Add Payments
                  </router-link>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-8">
                      <input type="text" class="form-control" placeholder="Search" v-model="inputFilter" v-on:keyup="searchFilter">
                    </div>
                    <div class="col-md-2">
                      <div class="basic_dropdown" v-click-outside="hideBtnstatus">
                        <button class="btn-status"  @click="btnstatus()">Status <i class="fas fa-caret-down"></i></button>
                        <ul class="reset dropdStatus" v-if="statusdropd">
                          <li>
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" class="custom-control-input" id="check12" @click="checkAll()" v-model="isCheckAll">
                              <label class="custom-control-label" for="check12"><b>All</b></label>
                            </div>
                          </li>
                          <li v-for="(item,index) in statusdata" :key="index">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" class="custom-control-input" :id="index" v-bind:value="item.value" v-model="statuslist" @change="searchFilter">
                              <label class="custom-control-label" :for="index">{{item.name}}</label>
                            </div>
                          </li>
                        </ul>
                      </div>
                   </div>
                    <div class="col-md-2">
                      <select v-model="paginador" class="form-control" @change="searchFilterPaginador">
                        <option value="0">Display</option>
                        <option value="200">200</option>
                        <option value="300">300</option>
                        <option value="500">500</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <Loader v-if="isLoading"></Loader>
                <div v-else>
                  <table class="table table-striped" v-if="PaymentList.length > 0">
                    <thead>
                      <tr>
                        <th scope="col">Payment #</th>
                        <th scope="col">Date</th>
                        <th scope="col">Name</th>
                        <th scope="col" style="text-align:center;">Invoice</th>
                        <th scope="col" style="text-align:center;">Amount</th>
                        <th scope="col" style="text-align:center;">Status</th>
                        <th scope="col" style="text-align:center;">Email</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in PaymentList" :key="item.id">
                        <th scope="row">
                          {{item.idx.toString().padStart(4,"000")}}
                          <NotesAdmin type='Payment' :id="item.id" sTxt="display:none;" :btnNotes="item.notes" style="float:right;"/>
                        </th>
                        <td>{{item.fecha}}</td>
                        <td>{{item.firstname}} {{item.lastname}} 
                          <br>
                          <span style="color:#a9a9a9">{{item.bussinesname}}</span>
                        </td>
                        <td style="text-align:center;">{{ item.numdoc }}</td>
                        <td style="text-align:center;">$ {{item.price}}</td>
                        <td style="text-align:center;">
                            <span v-if="item.status == 1" class="badge badge-success">Accepted</span>
                            <span v-if="item.status == 0" class="badge badge-danger" style="background-color:#f70d0d">Void</span>
                        </td>
                        <td  style="text-align:center;">
                          <button style="border:0;background: transparent;cursor:pointer;font-size:13px;" @click="actionEmail(item.id, item.email, item.idx.toString().padStart(4,'000'))">
                            {{item.numenv}}
                            <i class="fas fa-envelope" style="color:#f89406; font-size:18px;"></i>
                          </button>
                        </td>
                        <td style="width:85px">
                          <span class="cdropdown">
                            <button>Actions</button>
                            <label>
                              <input type="checkbox">
                              <ul>
                                <li @click="actionEdit(item.id)"><button><i class="fas fa-edit"></i> Edit</button></li>
                                <li v-if="item.status == 1" @click="anularPago(item.id, item.invoice_id)"><button><i class="fas fa-trash-alt"></i> Void</button></li>
                                <li  @click="elimPago(item.id,item.invoice_id,item.img1,item.img2)"><button><i class="fas fa-times"></i> Delete</button></li>
                              </ul>
                            </label>
                          </span>
                        </td>
                      </tr>  
                    </tbody>
                  </table>
                  <div class="text-center d-block w-100 p20" v-else>
                    <div class="text-center" style="padding:30px;"> 
                      <span style="padding-bottom:30px">No record </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <modal name="modal-setting" height="auto" @before-close="ClosedModal">
      <div class="card">
      <component :is="SettingBox" :items="mailPayment"></component>
      </div>
    </modal>
    <notifications group="noti" position="top center">
</notifications>
  </billing-layout>
</template>
<script>
  import axios from 'axios'
  import Loader from '@/components/shared/Loader'
  import BillingLayout from '@/Layouts/Billing/BillingLayout'
  import modalEmail from '@/components/billing/modalEmail'
  import EventBus from '@/eventBus'
  import NotesAdmin from '@/components/billing/NotesAdmin.vue';
import ClickOutside from 'vue-click-outside';
  export default {
    name:'Payment',
    components:{
      Loader,
      BillingLayout,
      modalEmail,
      NotesAdmin
    },
    data() {
      return{
        isLoading : false,
        PaymentList : [],
        mailPayment : {
          isLoading : false,
          id : null,
          IDitem : null, // numdoc
          email : null,
          EmailCheck : false,
          view : 'payment',
        },
        SettingBox : '',
        emailsp : [],
          inputFilter: '',
          OldPaymentsList: [],
          invStatus:0,
          isFilter: false,          
           isCheckAll: true,
           statusdata: [
             {'value' : '1','name' : 'Accepted'},
             {'value' : '0','name' : 'Void'}
           ],
           statuslist: [1,0],
           statusdropd : false,
           paginador: 0,
      } 
    },
    created(){
      this.getlist();
    },
    mounted(){
    },
    directives: {
      ClickOutside
    },
    methods:{
      abrirCanalEventBus(){
          let vm = this;
          EventBus.$on('payment-email',(item)=>{
            this.emailsp =item; 
            vm.sendMailPayment(item);
          }); 
        },

        btnstatus(){
         this.statusdropd = !this.statusdropd;
        },
        hideBtnstatus(){
          this.statusdropd = false;
        },
        checkAll: function(){

          this.isCheckAll = !this.isCheckAll;
          this.statuslist = [];
          if(this.isCheckAll){
            for (var key in this.statusdata) {
              this.statuslist.push(this.statusdata[key].value);
            }
            this.searchFilter();
          }
        },
        updateCheckall: function(){
            if(this.statuslist.length == this.statusdata.length){
              this.isCheckAll = true;
            }else{
              this.isCheckAll = false;
            }
        },
        searchFilter(){          
          if(this.inputFilter.length > 1 || this.statuslist.length > 0)
          {
            this.isLoading = true;
            window.billing.post('filterpayments', 
              {
                user_id: window.localuserdata, 
                filter:this.inputFilter,
                status: this.statuslist,
                pag: this.paginador
              }
            ).then((response) => {
                  //console.log('filter ',response.data.result);
                  let listFilter = response.data.result;
                  let e = listFilter;
                  for (var i = 0; i < e.length; i++) {
                    let fecha= new Date(e[i].fecha).toDateString().slice(4,15);
                    let fecha_new= fecha.split(' ');
                    listFilter[i].fecha=fecha_new[0]+' '+fecha_new[1]+', '+fecha_new[2];
                  }
                  this.PaymentList=listFilter;
                  this.isFilter= true;
                  this.isLoading = false;
             }).catch((error) => {
                this.isLoading = false;
                console.log(error);
            });
          }
          else
          {
            this.PaymentList=this.OldPaymentsList;
            this.isLoading = false;
            this.isFilter= false;
          }
        },
        searchFilterPaginador(){          
          if(this.paginador > 0)
          {
            this.searchFilter();
          }
          else
          {
            this.PaymentList=this.OldPaymentsList;
            this.isLoading = false;
            this.isFilter= false;
          }
        },
      actionEmail(id,email,numdoc){
        this.$modal.show('modal-setting');
        this.SettingBox = 'modalEmail';
        this.mailPayment.idinv = id; // id de payment 
        this.mailPayment.IDitem = numdoc;
        this.mailPayment.email = email;
        this.abrirCanalEventBus();
      },
      sendMailPayment(item){
        if(item.DataItem.send==1){
          item.DataItem.send=0;
          this.$modal.hide('modal-setting');
          this.SettingBox = '';
          this.getlist();
          this.$notify({
            group: 'noti',
            title: 'Success',
            type: 'success',
            text: 'Send Mail!'
          });
          EventBus.$off('payment-email');
        }
      },      
      ClosedModal(){
          this.SettingBox =''
      },
      getlist(){
        this.isLoading = true;
        window.billing.get('payments/' + window.localuserdata)
        .then((response) => {
          console.log(response.data.result);
          this.PaymentList = response.data.result;
          let e = this.PaymentList;
          for (var i = 0; i < e.length; i++) {
            let fecha= new Date(e[i].fecha).toDateString().slice(4,15);
            let fecha_new= fecha.split(' ');
            this.PaymentList[i].fecha=fecha_new[0]+' '+fecha_new[1]+', '+fecha_new[2];
          }
          this.OldPaymentsList=this.PaymentList;
  				this.isLoading = false;
        }).catch((error) => {           
          this.isLoading = false;
          console.log(error);
        });
      },
      actionEdit(id){
        this.$router.push({name:'PaymentsReceivedNew', params:{idpay:id}});
      },        
      anularPago(id, idi)
      {
        this.isLoading = true;
        this.$swal({
          title: "Void this Payment?",
          text: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Void it!"
        }).then((result) => {
          if (result.value)
          {
            window.billing.put('payments/anular/' + id, {
              user_id: window.localuserdata,
              invoice_id: idi
            })
            .then((response) => {
              console.log(response.data);
              this.isLoading = false;
              if(response.data.status){
                this.getlist();
                this.$notify({
                        group: 'noti',
                        title: 'Void!',
                        type: 'success',
                        text: 'Void Payment Successful',
                    }); 
              
              }
            }).catch((error) => {
              this.isLoading = false;
              console.log(error);
            });
          }
        });
        this.isLoading = false   
      },     
      elimPago(id, idi, img1, img2)
      {
        this.isLoading = true;
        this.$swal({
          title: "Delete this Payment?",
          text: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Delete it!"
        }).then((result) => {
          if (result.value)
          {
            window.billing.put('payments/trash/' + id, {
              user_id: window.localuserdata,
              invoice_id: idi,
              folder_user: localStorage.getItem('folder_user')
            })
            .then((response) => {
              console.log(response.data);
              if(response.data.status){
                this.getlist();
                this.elimIMG(img1, img2)
              }else{this.isLoading = false;}
            }).catch((error) => {
              this.isLoading = false;
              console.log(error);
            });
          }
        });
        this.isLoading = false   
      },
      elimIMG(img1, img2){
        console.log('imgs', img1, img2);
        let cont=0;
        let form = {};
        form['org_id']=window.localuserdata;
        form['folder']='payments';
        form['delIMG']='img';
        if(img1!=null && img1!='' && img1!='null'){
          cont++; form['img'+cont]=img1;
        }
        if(img2!=null && img2!='' && img2!='null'){
         cont++; form['img'+cont]=img2; 
        }
        form['contDel']=cont;
        if(cont > 0)
        {
          window.master.post('deleteimgs', form)
          .then((response) => {
              console.log(response.data.imgs);
              this.$notify({
                group: 'noti',
                title: 'Delete!',
                type: 'success',
                text: 'Delete Payment Successful',
              });
              this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(error);
          });
        }
        else
        {
          this.$notify({
            group: 'noti',
            title: 'Delete!',
            type: 'success',
            text: 'Delete Payment Successful',
          });
          this.isLoading = false;
        }

      },
    }
  };
</script>
<style scope="sass">

</style>
